module.exports = __webpack_public_path__ + "img/chevron-expand.6897ecd5.svg";